module.exports = __webpack_public_path__ + "img/logoteczoav1.513a2786.png";